import { Edit, SimpleForm } from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UserCog } from "lucide-react";
import {
  EmployeeBankInputs,
  EmployeeCoreInputs,
  EmployeeGovernmentInputs,
  EmployeePersonalInputs,
} from "./EmployeeInputs";

export const EmployeeEdit = () => (
  <Edit title="Edit Employee" actions={false}>
    <SimpleForm className="max-w-4xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <UserCog className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Edit Employee Details</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6 space-y-8">
          <EmployeeCoreInputs />
          <EmployeePersonalInputs />
          <EmployeeGovernmentInputs />
          <EmployeeBankInputs />
        </CardContent>
      </Card>
    </SimpleForm>
  </Edit>
);
